const name = 'circle-d';


const contents = `
<circle cx="31" cy="41" r="29"/>
<path d="M31.289 26.829c2.265 0 4.184.359 5.758 1.077 1.575.718 2.859 1.698 3.853 2.941.995 1.243 1.726 2.72 2.196 4.433.47 1.712.704 3.563.704 5.551 0 1.989-.235 3.853-.704 5.593-.47 1.74-1.201 3.246-2.196 4.516-.994 1.27-2.278 2.265-3.853 2.983C35.473 54.64 33.554 55 31.29 55H20.932V26.829h10.357zm0 4.64h-4.972V50.36h4.972c2.54 0 4.322-.87 5.344-2.61 1.022-1.74 1.533-4.046 1.533-6.919 0-2.872-.511-5.15-1.533-6.835-1.022-1.685-2.803-2.527-5.344-2.527z" fill="#FFF"/>
`;


/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'D',
};

export default icon;
